// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__1Ujj2","tabs":"LayoutWrapperSideNav_tabs__1p27j","tab":"LayoutWrapperSideNav_tab__3C83I"};